module.exports = __webpack_public_path__ + "why12.png?e00306799076eaf82eee9cb82d7810c2";